// First sign-in phone step. Existing users with PhoneOnboardingRequired false are not asked again.

export const COUNTRIES = [
    { iso: 'IN', name: 'India', dial: '+91', min: 10, max: 10 },
    { iso: 'US', name: 'United States', dial: '+1', min: 10, max: 10 },
    { iso: 'CA', name: 'Canada', dial: '+1', min: 10, max: 10 },
    { iso: 'GB', name: 'United Kingdom', dial: '+44', min: 10, max: 10 },
    { iso: 'AE', name: 'United Arab Emirates', dial: '+971', min: 9, max: 9 },
    { iso: 'SA', name: 'Saudi Arabia', dial: '+966', min: 9, max: 9 },
    { iso: 'QA', name: 'Qatar', dial: '+974', min: 8, max: 8 },
    { iso: 'AU', name: 'Australia', dial: '+61', min: 9, max: 9 },
    { iso: 'NZ', name: 'New Zealand', dial: '+64', min: 8, max: 10 },
    { iso: 'SG', name: 'Singapore', dial: '+65', min: 8, max: 8 },
    { iso: 'MY', name: 'Malaysia', dial: '+60', min: 9, max: 10 },
    { iso: 'PH', name: 'Philippines', dial: '+63', min: 10, max: 10 },
    { iso: 'ID', name: 'Indonesia', dial: '+62', min: 9, max: 12 },
    { iso: 'TH', name: 'Thailand', dial: '+66', min: 9, max: 9 },
    { iso: 'VN', name: 'Vietnam', dial: '+84', min: 9, max: 10 },
    { iso: 'JP', name: 'Japan', dial: '+81', min: 10, max: 10 },
    { iso: 'KR', name: 'South Korea', dial: '+82', min: 9, max: 10 },
    { iso: 'CN', name: 'China', dial: '+86', min: 11, max: 11 },
    { iso: 'HK', name: 'Hong Kong', dial: '+852', min: 8, max: 8 },
    { iso: 'DE', name: 'Germany', dial: '+49', min: 10, max: 11 },
    { iso: 'FR', name: 'France', dial: '+33', min: 9, max: 9 },
    { iso: 'IT', name: 'Italy', dial: '+39', min: 9, max: 10 },
    { iso: 'ES', name: 'Spain', dial: '+34', min: 9, max: 9 },
    { iso: 'NL', name: 'Netherlands', dial: '+31', min: 9, max: 9 },
    { iso: 'BE', name: 'Belgium', dial: '+32', min: 8, max: 9 },
    { iso: 'SE', name: 'Sweden', dial: '+46', min: 7, max: 10 },
    { iso: 'CH', name: 'Switzerland', dial: '+41', min: 9, max: 9 },
    { iso: 'IE', name: 'Ireland', dial: '+353', min: 9, max: 9 },
    { iso: 'ZA', name: 'South Africa', dial: '+27', min: 9, max: 9 },
    { iso: 'NG', name: 'Nigeria', dial: '+234', min: 10, max: 10 },
    { iso: 'KE', name: 'Kenya', dial: '+254', min: 9, max: 9 },
    { iso: 'BR', name: 'Brazil', dial: '+55', min: 10, max: 11 },
    { iso: 'MX', name: 'Mexico', dial: '+52', min: 10, max: 10 },
    { iso: 'PK', name: 'Pakistan', dial: '+92', min: 10, max: 10 },
    { iso: 'BD', name: 'Bangladesh', dial: '+880', min: 10, max: 10 },
    { iso: 'LK', name: 'Sri Lanka', dial: '+94', min: 9, max: 9 },
    { iso: 'NP', name: 'Nepal', dial: '+977', min: 10, max: 10 },
    { iso: 'AF', name: 'Afghanistan', dial: '+93', min: 9, max: 9 },
    { iso: 'AL', name: 'Albania', dial: '+355', min: 8, max: 9 },
    { iso: 'DZ', name: 'Algeria', dial: '+213', min: 9, max: 9 },
    { iso: 'AD', name: 'Andorra', dial: '+376', min: 6, max: 9 },
    { iso: 'AO', name: 'Angola', dial: '+244', min: 9, max: 9 },
    { iso: 'AR', name: 'Argentina', dial: '+54', min: 10, max: 10 },
    { iso: 'AM', name: 'Armenia', dial: '+374', min: 8, max: 8 },
    { iso: 'AT', name: 'Austria', dial: '+43', min: 10, max: 11 },
    { iso: 'AZ', name: 'Azerbaijan', dial: '+994', min: 9, max: 9 },
    { iso: 'BH', name: 'Bahrain', dial: '+973', min: 8, max: 8 },
    { iso: 'BS', name: 'Bahamas', dial: '+1', min: 10, max: 10 },
    { iso: 'BB', name: 'Barbados', dial: '+1', min: 10, max: 10 },
    { iso: 'BY', name: 'Belarus', dial: '+375', min: 9, max: 9 },
    { iso: 'BZ', name: 'Belize', dial: '+501', min: 7, max: 7 },
    { iso: 'BJ', name: 'Benin', dial: '+229', min: 8, max: 8 },
    { iso: 'BT', name: 'Bhutan', dial: '+975', min: 8, max: 8 },
    { iso: 'BO', name: 'Bolivia', dial: '+591', min: 8, max: 8 },
    { iso: 'BA', name: 'Bosnia and Herzegovina', dial: '+387', min: 8, max: 8 },
    { iso: 'BW', name: 'Botswana', dial: '+267', min: 8, max: 8 },
    { iso: 'BN', name: 'Brunei', dial: '+673', min: 7, max: 7 },
    { iso: 'BG', name: 'Bulgaria', dial: '+359', min: 8, max: 9 },
    { iso: 'BF', name: 'Burkina Faso', dial: '+226', min: 8, max: 8 },
    { iso: 'KH', name: 'Cambodia', dial: '+855', min: 8, max: 9 },
    { iso: 'CM', name: 'Cameroon', dial: '+237', min: 9, max: 9 },
    { iso: 'CL', name: 'Chile', dial: '+56', min: 9, max: 9 },
    { iso: 'CO', name: 'Colombia', dial: '+57', min: 10, max: 10 },
    { iso: 'CR', name: 'Costa Rica', dial: '+506', min: 8, max: 8 },
    { iso: 'HR', name: 'Croatia', dial: '+385', min: 8, max: 9 },
    { iso: 'CU', name: 'Cuba', dial: '+53', min: 8, max: 8 },
    { iso: 'CY', name: 'Cyprus', dial: '+357', min: 8, max: 8 },
    { iso: 'CZ', name: 'Czech Republic', dial: '+420', min: 9, max: 9 },
    { iso: 'DK', name: 'Denmark', dial: '+45', min: 8, max: 8 },
    { iso: 'DO', name: 'Dominican Republic', dial: '+1', min: 10, max: 10 },
    { iso: 'EC', name: 'Ecuador', dial: '+593', min: 9, max: 9 },
    { iso: 'EG', name: 'Egypt', dial: '+20', min: 10, max: 10 },
    { iso: 'SV', name: 'El Salvador', dial: '+503', min: 8, max: 8 },
    { iso: 'EE', name: 'Estonia', dial: '+372', min: 7, max: 8 },
    { iso: 'ET', name: 'Ethiopia', dial: '+251', min: 9, max: 9 },
    { iso: 'FJ', name: 'Fiji', dial: '+679', min: 7, max: 7 },
    { iso: 'FI', name: 'Finland', dial: '+358', min: 9, max: 10 },
    { iso: 'GH', name: 'Ghana', dial: '+233', min: 9, max: 9 },
    { iso: 'GR', name: 'Greece', dial: '+30', min: 10, max: 10 },
    { iso: 'GT', name: 'Guatemala', dial: '+502', min: 8, max: 8 },
    { iso: 'GY', name: 'Guyana', dial: '+592', min: 7, max: 7 },
    { iso: 'HT', name: 'Haiti', dial: '+509', min: 8, max: 8 },
    { iso: 'HN', name: 'Honduras', dial: '+504', min: 8, max: 8 },
    { iso: 'HU', name: 'Hungary', dial: '+36', min: 8, max: 9 },
    { iso: 'IS', name: 'Iceland', dial: '+354', min: 7, max: 7 },
    { iso: 'IR', name: 'Iran', dial: '+98', min: 10, max: 10 },
    { iso: 'IQ', name: 'Iraq', dial: '+964', min: 10, max: 10 },
    { iso: 'IL', name: 'Israel', dial: '+972', min: 9, max: 9 },
    { iso: 'JM', name: 'Jamaica', dial: '+1', min: 10, max: 10 },
    { iso: 'JO', name: 'Jordan', dial: '+962', min: 9, max: 9 },
    { iso: 'KZ', name: 'Kazakhstan', dial: '+7', min: 10, max: 10 },
    { iso: 'KW', name: 'Kuwait', dial: '+965', min: 8, max: 8 },
    { iso: 'KG', name: 'Kyrgyzstan', dial: '+996', min: 9, max: 9 },
    { iso: 'LA', name: 'Laos', dial: '+856', min: 8, max: 10 },
    { iso: 'LV', name: 'Latvia', dial: '+371', min: 8, max: 8 },
    { iso: 'LB', name: 'Lebanon', dial: '+961', min: 7, max: 8 },
    { iso: 'LY', name: 'Libya', dial: '+218', min: 9, max: 9 },
    { iso: 'LT', name: 'Lithuania', dial: '+370', min: 8, max: 8 },
    { iso: 'LU', name: 'Luxembourg', dial: '+352', min: 9, max: 9 },
    { iso: 'MG', name: 'Madagascar', dial: '+261', min: 9, max: 9 },
    { iso: 'MW', name: 'Malawi', dial: '+265', min: 9, max: 9 },
    { iso: 'MV', name: 'Maldives', dial: '+960', min: 7, max: 7 },
    { iso: 'ML', name: 'Mali', dial: '+223', min: 8, max: 8 },
    { iso: 'MT', name: 'Malta', dial: '+356', min: 8, max: 8 },
    { iso: 'MU', name: 'Mauritius', dial: '+230', min: 8, max: 8 },
    { iso: 'MD', name: 'Moldova', dial: '+373', min: 8, max: 8 },
    { iso: 'MN', name: 'Mongolia', dial: '+976', min: 8, max: 8 },
    { iso: 'ME', name: 'Montenegro', dial: '+382', min: 8, max: 8 },
    { iso: 'MA', name: 'Morocco', dial: '+212', min: 9, max: 9 },
    { iso: 'MZ', name: 'Mozambique', dial: '+258', min: 9, max: 9 },
    { iso: 'MM', name: 'Myanmar', dial: '+95', min: 8, max: 10 },
    { iso: 'NA', name: 'Namibia', dial: '+264', min: 9, max: 9 },
    { iso: 'NI', name: 'Nicaragua', dial: '+505', min: 8, max: 8 },
    { iso: 'NE', name: 'Niger', dial: '+227', min: 8, max: 8 },
    { iso: 'MK', name: 'North Macedonia', dial: '+389', min: 8, max: 8 },
    { iso: 'NO', name: 'Norway', dial: '+47', min: 8, max: 8 },
    { iso: 'OM', name: 'Oman', dial: '+968', min: 8, max: 8 },
    { iso: 'PA', name: 'Panama', dial: '+507', min: 8, max: 8 },
    { iso: 'PG', name: 'Papua New Guinea', dial: '+675', min: 8, max: 8 },
    { iso: 'PY', name: 'Paraguay', dial: '+595', min: 9, max: 9 },
    { iso: 'PE', name: 'Peru', dial: '+51', min: 9, max: 9 },
    { iso: 'PL', name: 'Poland', dial: '+48', min: 9, max: 9 },
    { iso: 'PT', name: 'Portugal', dial: '+351', min: 9, max: 9 },
    { iso: 'RO', name: 'Romania', dial: '+40', min: 9, max: 9 },
    { iso: 'RU', name: 'Russia', dial: '+7', min: 10, max: 10 },
    { iso: 'RW', name: 'Rwanda', dial: '+250', min: 9, max: 9 },
    { iso: 'SN', name: 'Senegal', dial: '+221', min: 9, max: 9 },
    { iso: 'RS', name: 'Serbia', dial: '+381', min: 8, max: 9 },
    { iso: 'SL', name: 'Sierra Leone', dial: '+232', min: 8, max: 8 },
    { iso: 'SK', name: 'Slovakia', dial: '+421', min: 9, max: 9 },
    { iso: 'SI', name: 'Slovenia', dial: '+386', min: 8, max: 8 },
    { iso: 'SO', name: 'Somalia', dial: '+252', min: 8, max: 8 },
    { iso: 'SD', name: 'Sudan', dial: '+249', min: 9, max: 9 },
    { iso: 'SY', name: 'Syria', dial: '+963', min: 9, max: 9 },
    { iso: 'TW', name: 'Taiwan', dial: '+886', min: 9, max: 9 },
    { iso: 'TJ', name: 'Tajikistan', dial: '+992', min: 9, max: 9 },
    { iso: 'TZ', name: 'Tanzania', dial: '+255', min: 9, max: 9 },
    { iso: 'TG', name: 'Togo', dial: '+228', min: 8, max: 8 },
    { iso: 'TT', name: 'Trinidad and Tobago', dial: '+1', min: 10, max: 10 },
    { iso: 'TN', name: 'Tunisia', dial: '+216', min: 8, max: 8 },
    { iso: 'TR', name: 'Turkey', dial: '+90', min: 10, max: 10 },
    { iso: 'TM', name: 'Turkmenistan', dial: '+993', min: 8, max: 8 },
    { iso: 'UG', name: 'Uganda', dial: '+256', min: 9, max: 9 },
    { iso: 'UA', name: 'Ukraine', dial: '+380', min: 9, max: 9 },
    { iso: 'UY', name: 'Uruguay', dial: '+598', min: 8, max: 8 },
    { iso: 'UZ', name: 'Uzbekistan', dial: '+998', min: 9, max: 9 },
    { iso: 'VE', name: 'Venezuela', dial: '+58', min: 10, max: 10 },
    { iso: 'YE', name: 'Yemen', dial: '+967', min: 9, max: 9 },
    { iso: 'ZM', name: 'Zambia', dial: '+260', min: 9, max: 9 },
    { iso: 'ZW', name: 'Zimbabwe', dial: '+263', min: 9, max: 9 },
]

export const normalizeDial = value => {
    const digits = String(value || '').replace(/\D/g, '').slice(0, 3)
    if (!digits) return ''
    return `+${digits}`
}

export const countryMatches = value => {
    const text = String(value || '').trim().toLowerCase()
    if (!text) return COUNTRIES
    const dial = normalizeDial(text)
    const byDial = dial ? COUNTRIES.filter(item => item.dial.startsWith(dial)) : []
    const byName = COUNTRIES.filter(item => item.name.toLowerCase().includes(text.replace(/^\+/, '')))
    const seen = new Set()
    return [...byDial, ...byName].filter(item => {
        if (seen.has(item.iso)) return false
        seen.add(item.iso)
        return true
    })
}

export const exactCountries = value => {
    const dial = normalizeDial(value)
    if (!dial) return []
    return COUNTRIES.filter(item => item.dial === dial)
}

export const countryLabel = list => {
    if (!list.length) return ''
    if (list.length <= 3) return list.map(item => item.name).join(', ')
    const [first, second, ...rest] = list
    return `${first.name}, ${second.name} and ${rest.length} more`
}

export const savedPhone = user => {
    const value = user?.PhoneE164 || user?.Phone || user?.PhoneNo || user?.MobileNo || ''
    return String(value).trim()
}

// Temporarily off so other company work is not interrupted. Set true to show the first sign-in phone step again.
export const PHONE_ONBOARDING_ENABLED = false

export const needsPhoneOnboarding = user => {
    if (!PHONE_ONBOARDING_ENABLED) return false
    if (!user) return false
    if (user.PhoneOnboardingRequired === false) return false
    if (user.PhoneOnboardingRequired === true) return true
    return !savedPhone(user)
}

export const phoneOnboardingPath = returnUrl => {
    if (!returnUrl) return '/complete-phone'
    return `/complete-phone?returnUrl=${encodeURIComponent(returnUrl)}`
}

export const validatePhone = (iso, raw, codeText) => {
    const exact = exactCountries(codeText)
    const picked = COUNTRIES.find(item => item.iso === iso)
    let selected = picked && exact.some(item => item.iso === picked.iso) ? picked : null
    if (!selected && exact.length === 1) {
        const [only] = exact
        selected = only
    }
    if (!selected && exact.length > 1) {
        const [first] = exact
        selected = {
            ...first,
            name: countryLabel(exact),
            min: Math.min(...exact.map(item => item.min)),
            max: Math.max(...exact.map(item => item.max)),
        }
    }
    if (!selected) return { ok: false, error: 'Type a country code, such as +355. The country name appears when the code matches.' }
    const trimmed = String(raw || '').trim()
    if (!trimmed) return { ok: false, error: 'Enter your phone number.' }
    if (trimmed.includes('+')) {
        return { ok: false, error: 'Enter the number without the country code. The code is already selected.' }
    }
    let digits = trimmed.replace(/\D/g, '')
    if (digits.startsWith('0')) digits = digits.replace(/^0+/, '')
    if (!digits) return { ok: false, error: 'Use digits only.' }
    if (digits.length < selected.min || digits.length > selected.max) {
        const span = selected.min === selected.max ? `${selected.min} digits` : `${selected.min} to ${selected.max} digits`
        return { ok: false, error: `${selected.name} numbers are ${span} after ${selected.dial}.` }
    }
    const phone = `${selected.dial}${digits}`
    if (phone.replace('+', '').length > 15) return { ok: false, error: 'That number is too long.' }
    return { ok: true, phone, national: digits, country: selected }
}
